module.exports = __webpack_public_path__ + "img/about-03.874bc755.jpg";